/** @format */

import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { globalServices } from "../../../Services/global.service";
import { initialStateService } from "../../../Services/AccountingServices/initialState.service";
import ResultModal from "../../Common/ResultModal";
import AddProductModal from "../../Common/AddProductModal";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as dateHelper from "../../../Helpers/DateHelper";
import cellEditFactory from "react-bootstrap-table2-editor";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import SpinnerLoading from "../../Common/SpinnerLoading";
import ActionModal from "../../Common/ActionModal";
import ProductsFilterModal from "../../Common/ProductsFilterModal";
import { AuthContext } from "../../../Contexts/AuthContext";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { numbersAndDot } from "../../../Config/Regex";
import XLSX from "xlsx";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";
import { Dropdown, Modal } from "react-bootstrap";
import CsvImport from "../../Common/CsvImport";
import { add } from "date-fns";
const DocumentDetails = (props) => {
  const { isMobile } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const history = useHistory();
  const { useAccounting } = useContext(AuthContext);
  const { register, handleSubmit, getValues, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [update, setUpdate] = useState(new Date());
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [modalValidationMsg, setModalValidationMsg] = useState("");
  const [showImportModal, setShowImportModal] = useState(false);

  const [initValue, setInitValue] = useState({
    date: null,
    storeId: 0,
    storeName: "",
    note: "",
    documentNumber: null,
    documentGuid: "",
    parentGuid: null,
  });

  const [actionModal, setActionModal] = useState({
    title: "",
    text: "",
    show: false,
    confirmBtn: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const addFilterProducts = (filterProducts) => {
    alert("2");
    let newArr = [...products];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      products.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false,
      ),
    );

    let oldDeleted2 = oldDeleted.filter((f) =>
      filterProducts.some((item) => item.productGuid === f.productGuid),
    );

    //vraćam ih na isActive true
    oldDeleted2.forEach((el) => (el.isActive = true));

    //uklanjanje duplikata
    oldDeleted = oldDeleted.filter((f) =>
      oldDeleted2.some((item) => item.productGuid !== f.productGuid),
    );

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid),
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);

    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid),
    );

    alert("1");
    console.log("addedProducts", addedProducts);

    let newProducts = addedProducts.map((prod) => ({
      documentDetailGuid: prod.documentDetailGuid,
      productGuid: prod.productGuid,
      productName: prod.productName,
      priceIn: prod.price,
      priceOut: Number(prod.price),
      priceOut2: Number(prod.price),
      quantityIn: Number(prod.quantity),
      margin: 0,
      isActive: true,
      tax: prod.tax,
      unitOfMeasure: prod.unitMeasureName,
    }));

    newArr = newArr.concat(newProducts);

    let shouldRemove = newArr.filter(
      (e) => e.documentDetailGuid === null && e.isActive === false,
    );

    newArr = newArr.filter((el) => !shouldRemove.includes(el));

    setIsDisabled(false);
    setProducts(newArr);
  };

  const addNewProduct = (productGuid, productName, priceIn, rest) => {
    setProducts([
      ...products,
      {
        documentDetailGuid: null,
        productGuid,
        productName,
        priceIn,
        quantityIn: 0,
        isActive: true,
      },
    ]);
    setIsDisabled(false);
  };

  const onSubmit = (data) => {
    initialStateService
      .documentUpdate(
        initValue.documentGuid,
        initValue.date,
        initValue.storeId,
        data.note,
        products,
      )
      .then((res) => {
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateSuccess-Title",
            text: "InitialState-ResultModal-UpdateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCancel = () => {
    history.push("/initial-state");
  };

  const handleClose = () => {
    setModal({ ...modal, show: false });
    if (modal.success === true) {
      history.push("/initial-state");
    }
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");

    initialStateService
      .getDocumentById(props.match.params.documentId)
      .then((res) => {
        if (res.data.data !== null) {
          setInitValue({
            ...initValue,
            date: res.data.data.date,
            storeId: Number(res.data.data.storeId),
            storeName: res.data.data.storeName,
            note: res.data.data.note,
            documentNumber: res.data.data.documentNumber,
            priceListId: res.data.data.priceListId,
            tenantId: res.data.data.tenantId,
            documentGuid: res.data.data.documentGuid,
            parentGuid: res.data.data.parentGuid,
          });
        }
        initialStateService
          .documentDetails(props.match.params.documentId)
          .then((res) => {
            console.log("data",res.data.data);

            setProducts(res.data.data.map((prod) => ({
            documentDetailGuid: prod.documentDetailGuid,
            productGuid: prod.productGuid,
            productName: prod.productName,
            priceIn: prod.priceIn,
            priceOut: Number(prod.priceIn),
            priceOut2: Number(prod.priceIn),
            quantityIn: Number(prod.quantityIn),
            margin: 0,
            isActive: true,
            tax: prod.tax,
            unitOfMeasure: prod.unitOfMeasure,
    })));
            setIsLoading(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => err);
  }, [update]);

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const handleLockDocument = () => {
    setActionModal({
      title: "InitialState-DocumentLock-Title",
      text: "InitialState-DocumentLock-Text",
      confirmBtn: "Confirm-Lock",
      confirmAction: confirmLock,
      show: true,
    });
  };

  const handleCancelDocument = () => {
    setActionModal({
      title: "InitialState-DocumentCancel-Title",
      text:
        initValue.parentGuid != null
          ? "Document-Cancel-Forbbiden"
          : "InitialState-DocumentCancel-Text",
      confirmBtn: initValue.parentGuid != null ? "" : "Confirm-Cancel",
      confirmAction: initValue.parentGuid != null ? () => false : confirmCancel,
      show: true,
    });
  };

  const handleDeleteDocument = () => {
    setActionModal({
      title: "InitialState-DocumentDelete-Title",
      text: "InitialState-DocumentDelete-Text",
      confirmBtn: "Confirm-Delete",
      confirmAction: confirmDelete,
      show: true,
    });
  };

  const handleHideActionModal = () =>
    setActionModal({ ...actionModal, show: false });

  const confirmLock = () => {
    initialStateService
      .documentLock(props.match.params.documentId)
      .then((res) => {
        setActionModal({ ...modal, show: false });
        if (res && res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockSuccess-Title",
            text: "InitialState-ResultModal-LockSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockError-Title",
            text: "InitialState-ResultModal-LockError-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const confirmDelete = () => {
    initialStateService
      .documentDelete(props.match.params.documentId)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        if (data.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteSuccess-Title",
            text: "InitialState-ResultModal-DeleteSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteError-Title",
            text: "InitialState-ResultModal-DeleteError-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "InitialState-ResultModal-DeleteError-Title",
          text: "InitialState-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
          success: false,
        }),
      );
  };

  const confirmCancel = () => {
    initialStateService
      .documentCancel(props.match.params.documentId)
      .then((res) => {
        setActionModal({ ...modal, show: false });
        if (res && res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CancelSuccess-Title",
            text: "InitialState-ResultModal-CancelSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CancelError-Title",
            text: "InitialState-ResultModal-CancelError-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const exportExcelFunction = () => {
    var ws_name = `Početno stanje ${initValue.documentNumber}.xlsx`;
    // New work book
    var wb = XLSX.utils.book_new();
    // Constant Data
    var ws_data = [
      [translator("InvIssReport-Filters-Tenants"), "Prodajno mjesto"],
      ["Tenant", initValue.storeName],
      [translator("InvoiceCashBalancePDF-Date"), "Broj dokumenta"],
      [dateHelper.formatUtcToDate(initValue.date), initValue.documentNumber],
      [
        translator("Proizvod"),
        `Prodajna cijena (${activeCurrencyByDate(initValue.date)})`,
        "Količina",
      ],
    ];
    // Inconsistent data / Reports
    const ws_sufix = products.map((x) => {
      const array = [x.productName, x.priceIn, x.quantityIn];
      return array;
    });
    // Merge data
    ws_data = [...ws_data, ...ws_sufix];
    // Export to xlsx
    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = [{ width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];
    XLSX.utils.book_append_sheet(wb, ws, "Početno stanje");
    XLSX.writeFile(wb, ws_name);
  };

  const options = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const { SearchBar } = Search;
  function currencyFormatter(cell, row) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(initValue.date),
    }).format(Number(cell));
  }
  function nameFormatter(cell, row) {
    return row.isRawMaterial ? cell + "(Sirovina)" : cell;
  }
  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      hidden: initValue.documentNumber ? true : false,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          let newArr = [...products];
          let item = newArr.find((p) => p.productGuid === row.productGuid);
          item.isActive = false;

          setProducts(newArr);
          setIsDisabled(false);
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
      formatter: nameFormatter,
      editable: false,
    },
    {
      dataField: "unitOfMeasure",
      text: translator("InitialState-UnitOfMeasure"),
      editable: false,
    },
    {
      dataField: "priceIn",
      text: translator("Nabavna cijena"),
      formatter: currencyFormatter,
      // editable: false,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "margin",
      text: `${translator("InitialState-Margin")}*`,
      searchable: false,
      formatter: (cell) => (cell || 0) + "%",
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        // setIsDisabled(false);
        return true;
      },
    },
    {
      dataField: "tax",
      text: `${translator("InitialState-Tax")}`,
      editable: false,
      formatter: (cell) => (cell || 0) + "%",
    },
    {
      dataField: "priceOut2",
      text: `${translator("InitialState-Price")}*`,
      formatter: currencyFormatter,
      editable: initValue.documentNumber ? false : true,
      searchable: false,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("PriceNotNegativeMsg"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("PriceMaxMsg"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
    {
      dataField: "quantityIn",
      text: `${translator("InitialState-Quantity")}*`,
      editable: initValue.documentNumber ? false : true,

      headerStyle: () => {
        return { width: "150px", textAlign: "left" };
      },
      style: () => {
        return { width: "150px", textAlign: "left", backgroundColor: "#ddd" };
      },
      validator: (newValue, row, column) => {
        if (
          isNaN(newValue) ||
          newValue == "" ||
          !numbersAndDot.test(newValue)
        ) {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("QuantityMaxThousand"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
  ];

  const EXCEL_HEADING = {
    documentDetailGuid: "documentDetailGuid",
    documentGuid: "documentGuid",
    productGuid: "productGuid",
    //
    productName: translator("InitialState-Product"),
    unitMeasureName: translator("InitialState-UnitOfMeasure"),
    priceIn: translator("Nabavna cijena"),
    margin: translator("InitialState-Margin"),
    tax: translator("InitialState-Tax"),
    priceOut2: translator("InitialState-PriceOut2"),
    price: translator("InitialState-Price"),
    quantityIn: translator("InitialState-Quantity"),
    //
    quantityOut: translator("InitialState-QuantityOut"),
    priceOut: translator("InitialState-PriceOut"),
    isRawMaterial: translator("InitialState-IsRawMaterial"),
    isActive: translator("InitialState-IsActive"),
  };

  const handleExport = () => {
    var ws_name = `${initValue?.storeName || ""}_${translator("InitialState-Items")}.xlsx`;
    // New work book
    var wb = XLSX.utils.book_new();
    // Constant Data
    var ws_data = [
      [
        EXCEL_HEADING.documentDetailGuid,
        EXCEL_HEADING.documentGuid,
        EXCEL_HEADING.productGuid,
        EXCEL_HEADING.productName,
        EXCEL_HEADING.unitMeasureName,
        EXCEL_HEADING.priceIn,
        EXCEL_HEADING.margin,
        EXCEL_HEADING.tax,
        EXCEL_HEADING.priceOut2,
        EXCEL_HEADING.price,
        EXCEL_HEADING.quantityIn,
        EXCEL_HEADING.quantityOut,
        EXCEL_HEADING.priceOut,
        EXCEL_HEADING.isRawMaterial,
        EXCEL_HEADING.isActive,
      ],
    ];

    // Inconsistent data / Reports
    const ws_sufix = products.map((x) => {
      const array = [
        x.documentDetailGuid,
        x.documentGuid,
        x.productGuid,
        x.productName,
        x.unitMeasureName,
        Number(x.priceIn) || 0,
        x.margin,
        x.tax,
        Number(x.priceOut2) || 0,
        Number(x.price) || 0,
        x.quantityIn,
        x.quantityOut,
        x.priceOut,
        x.isRawMaterial,
        x.isActive,
      ];
      return array;
    });
    // Merge data
    ws_data = [...ws_data, ...ws_sufix];
    // Export to xlsx
    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = [
      { width: 40 },
      { width: 40 },
      { width: 40 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    XLSX.utils.book_append_sheet(wb, ws, "Početno stanje");
    XLSX.writeFile(wb, ws_name);
  };

  return (
    <>
      <CardWrap subtitle={translator("DocumentDetails")}>
        {!isLoading ? (
          <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-IndexData")}
                </legend>
                <div className="form-group">
                  <div>
                    <label className="boldedDocNumber">
                      <b>{translator("InitialState-DocumentNumber")}:</b>{" "}
                      {initValue.documentNumber
                        ? initValue.documentNumber
                        : translator("Document-NotLocked")}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Date")}:</b>{" "}
                      {dateHelper.formatUtcToDate(initValue.date)}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Store")}:</b>{" "}
                      {initValue.storeName}
                    </label>
                  </div>
                  <div className="form-group">
                    <label>
                      <b>{translator("InitialState-Note")}:</b>
                    </label>
                    <textarea
                      name="note"
                      ref={register({ maxLength: 250 })}
                      className="form-control"
                      rows={4}
                      id="textArea"
                      defaultValue={initValue.note}
                      onChange={() => setIsDisabled(false)}
                      disabled={initValue.documentNumber ? true : false}
                    ></textarea>
                    {errors.note && errors.note.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength250")}
                      </p>
                    )}
                  </div>
                </div>
              </fieldset>

              <div
                class="custom-card-footer row"
                style={{ borderTop: "1px solid #ccc", paddingTop: "22px" }}
              >
                <label class="control-label col-md-12">
                  * {translator("DangerArea")}
                </label>
                <div className="col-md-6">
                  <button
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-outline-secondary btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLockDocument();
                    }}
                  >
                    {translator("Btn-Conclude")}
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    disabled={!initValue.documentNumber ? true : false}
                    className="btn btn-outline-secondary btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCancelDocument();
                    }}
                  >
                    {translator("Btn-CancelDoc")}
                  </button>
                </div>

                <div className="col-md-12 mt-3">
                  <button
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-danger btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDeleteDocument();
                    }}
                  >
                    {translator("Btn-RemoveDoc")}
                  </button>
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      exportExcelFunction();
                    }}
                    disabled={initValue.documentNumber ? false : true}
                    className="btn btn-outline-secondary btn-block"
                  >
                    {translator("Preuzmi dokument")}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-Items")}
                </legend>
                <ToolkitProvider
                  keyField="productGuid"
                  data={products.filter((item) => item.isActive === true)}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <>
                      {!initValue.documentNumber ? (
                        <div className="form-group">
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowFilterModal(true);
                            }}
                          >
                            <span className="icon icon-filter"></span>{" "}
                            {translator("Filter")}
                          </button>
                          &nbsp;
                          <Dropdown className="ml-2 float-right">
                            <Dropdown.Toggle
                              variant="outline-secondary"
                              id="dropdown-basic"
                            >
                             
                              <span className="mob-hidden">
                                {translator(
                                  "ListAdminButtons-Dropdown-Import-Export",
                                )}
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => setShowImportModal(true)}
                              >
                                <span className="">
                                  {isMobile
                                    ? translator(
                                        "ListAdminButtons-Dropdown-BulkImport-Mobile",
                                      )
                                    : translator(
                                        "ListAdminButtons-Dropdown-BulkImport",
                                      )}
                                </span>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={handleExport}>
                                <span className="">
                                  {isMobile
                                    ? translator(
                                        "ListAdminButtons-Dropdown-DataExport-Mobile",
                                      )
                                    : translator(
                                        "ListAdminButtons-Dropdown-DataExport",
                                      )}
                                </span>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                          <span className="text-danger ml-2">
                            {translator(modalValidationMsg)}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="form-group">
                        <SearchBar
                          {...props.searchProps}
                          placeholder={translator("Search")}
                          className="col-md-12"
                        />
                      </div>
                      <hr />
                      <BootstrapTable
                        {...props.baseProps}
                        noDataIndication={translator("No-Data")}
                        pagination={paginationFactory(options)}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: (oldValue, newValue, row, column) => {
                            if (column.dataField == "priceIn") {
                              row.priceIn = newValue;
                              let netPrice =
                                row.priceOut2 /
                                (1 + (row.tax ? row.tax / 100 : 0));

                              row.margin = +Number(
                                ((netPrice - newValue) / newValue) * 100,
                              ).toFixed(4);
                            }
                            if (column.dataField == "margin") {
                              row.priceOut2 =
                                Number(row.priceIn) *
                                (1 + +newValue / 100) *
                                (1 + (row.tax ? +row.tax / 100 : 0));
                              row.margin = +newValue;
                            }
                            if (column.dataField == "priceOut2") {
                              row.price = +newValue || 0;
                              let netPrice =
                                newValue / (1 + (row.tax ? row.tax / 100 : 0));

                              row.margin = Number(
                                ((netPrice - (row.priceIn || 0)) /
                                  (row.priceIn || 0)) *
                                  100,
                              ).toFixed(4);
                            }
                          },
                        })}
                      />
                      <p>
                        <span className="editableColumns">*</span>
                        {translator("EditableTableColumns")}
                      </p>
                    </>
                  )}
                </ToolkitProvider>
              </fieldset>
            </div>
            <div
              className="container-fluid mt-4"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={handleCancel}
              >
                {translator("POS-New_EditPOS-Close")}
              </button>
              &nbsp;
              <button
                className="btn btn-primary"
                disabled={isDisabled}
                type="submit"
              >
                {translator("POS-New_EditPOS-Save")}
              </button>
            </div>
          </form>
        ) : (
          <SpinnerLoading />
        )}
      </CardWrap>

      <Modal show={showImportModal} onHide={() => setShowImportModal(false)}>
        <CsvImport
          setResult={(data) => {
            let newProducts = data?.data?.map((prod) => ({
              documentDetailGuid: prod[EXCEL_HEADING.documentDetailGuid],
              documentGuid: prod[EXCEL_HEADING.documentGuid],
              productGuid: prod[EXCEL_HEADING.productGuid],
              productName: prod[EXCEL_HEADING.productName],
              unitMeasureName: prod[EXCEL_HEADING.unitMeasureName],
              priceIn: Number(prod[EXCEL_HEADING.priceIn]) || 0,
              margin: Number(prod[EXCEL_HEADING.margin]) || 0,
              tax: Number(prod[EXCEL_HEADING.tax]) || 0,
              priceOut2: Number(prod[EXCEL_HEADING.priceOut2]) || 0,
              price: Number(prod[EXCEL_HEADING.price]) || 0,
              quantityIn: Number(prod[EXCEL_HEADING.quantityIn]) || 0,
              quantityOut: Number(prod[EXCEL_HEADING.quantityOut]) || 0,
              priceOut: Number(prod[EXCEL_HEADING.priceOut]) || 0,
              isRawMaterial: Boolean(prod[EXCEL_HEADING.isRawMaterial]),
              isActive: Boolean(prod[EXCEL_HEADING.isActive]),
            }));

            setProducts(newProducts);
            setShowImportModal(false);
          }}
        />
      </Modal>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      <ActionModal
        show={actionModal.show}
        handleHide={handleHideActionModal}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
      {initValue.date !== null && (
        <ProductsFilterModal
          show={showFilterModal}
          storeId={initValue.storeId}
          documentOption={1}
          prodList={products.filter((item) => item.isActive === true)}
          handleHide={() => setShowFilterModal(false)}
          confirmAdd={addFilterProducts}
        />
      )}
      {initValue.date !== null && (
        <AddProductModal
          show={showProductModal}
          tenantId={initValue.tenantId}
          priceListId={initValue.priceListId}
          addNewProduct={addNewProduct}
          handleHide={() => setShowProductModal(false)}
        />
      )}
    </>
  );
};

export default DocumentDetails;
